import {Part} from "./part";
import {toiletThumbnail} from '../assets';
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {IntermediatePart} from "./intermediatePart";
import {Vanity} from "./vanity";

export class Toilet extends Part {
  static id = 'Toilet';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.menuType = PartMenuType.Complex;
    this.partName = 'Toilet';
    this.translateId = "visualizer.bathroom.toilet";
    this.homePageTitle = 'Toilets';
    this.partThumbnail = toiletThumbnail;
    this.toilet = null;
  }

  setLayers(layout, placeholdersNeeded){
    const layers = [];
    this.relatedItems.forEach(relatedItem => {
      relatedItem.setLayers(layout);
      (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
        ? relatedItem.placeholderFeature.layer.addTo(layers)
        : relatedItem.activeFeature ? relatedItem.activeFeature.layer.addTo(layers) : null

    });
    return layers;
  }

  load(dbFeature) {
    if (dbFeature.groupName === "Toilet") {
      if (!this.toilet) {
        this.toilet = new ToiletBody(true);
        this.relatedItems.push(this.toilet);
        this.toilet.getParent = () => this;
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this.toilet.load(dbFeature);
      return true
    }
    return false
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts() {
    return this.relatedItems.map(_ => new DesignNavigationItem(_.partName, _));
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  navigationItem() {
    return new DesignNavigationItem('Toilet', this)
  }

  setDefault(layout) {
    this.relatedItems.forEach(_ => _.setDefault(layout));
  }
}

class ToiletBody extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'toilet';
    this.partName = 'Toilet';
    this.translateId = "visualizer.bathroom.toilet";
    this.homePageTitle = 'Toilets';
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ToiletBody());
  }

  setLayers(layout) {

    const vanitySize = layout.parts[Vanity.id].counterTopSize();

    // console.log('Toilet - vanity size: ', vanitySize);
    if (vanitySize === '72in' || vanitySize === '60in') {
      // console.warn('Toilet - not visible for current vanity size: ', vanitySize);
      super.hideLayers();
      return;
    }

    return super.setLayers(layout);
  }

  setDefault(layout) {
    const hardCodedDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Melbourne MR4CGR");
    });
    const placeholderDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
    });
    this.activeFeature = hardCodedDefault || super.setDefault(layout) || this.features[0];
    this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Toilet;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.Toilet;
    }
  }
}


